import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHero from "@/components/site/PageHero";
import { getPage } from "@/lib/api";

export default function Legal() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "") || "privacy-policy";
  const [page, setPage] = useState(null);

  useEffect(() => { setPage(null); getPage(slug).then(setPage); }, [slug]);

  const title = page?.title || page?.hero_title || "Legal";

  return (
    <>
      <Seo title={page?.seo_title || `${title} | Legacy India Travel`} description={page?.seo_description || page?.intro || ""} />
      <PageHero
        title={page?.hero_title || title}
        image={page?.hero_image || "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=1600&q=80"}
        crumbs={[{ label: title }]}
      />
      <section className="py-16 sm:py-24 bg-[#fdfbf7]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8" data-testid={`legal-${slug}`}>
          {page?.intro && <p className="text-lg text-[#4a4a4a] leading-relaxed whitespace-pre-line">{page.intro}</p>}
          <div className="mt-10 space-y-9">
            {(page?.sections || []).map((s, i) => (
              <div key={i}>
                <h2 className="font-serif text-2xl text-[#3b1a1a]">{s.title}</h2>
                <p className="text-[#5a4b4b] mt-2 leading-relaxed whitespace-pre-line">{s.body}</p>
              </div>
            ))}
          </div>
          <p className="mt-12 text-sm text-[#5a4b4b]">Questions? Email <a href="mailto:haseeb@legacyindiatravel.com" className="text-[#7c1d1d]">haseeb@legacyindiatravel.com</a>.</p>
        </div>
      </section>
    </>
  );
}
